import { ChevronRightIcon } from "@heroicons/react/24/outline";
import React from "react";
import { Link } from "react-router-dom";

export interface BreadcrumbLink {
    label: string;
    to: string;
}

interface BreadcrumbsProps {
    links: BreadcrumbLink[];
    current: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = props => {
    const { links, current } = props;

    return (
        <nav aria-label="Breadcrumb" className="text-sm text-gray-500">
            <ol className="flex flex-wrap items-center gap-1">
                {links.map(link => (
                    <li key={link.to} className="inline-flex items-center gap-1">
                        <Link
                            to={link.to}
                            className="hover:text-gray-700 hover:underline">
                            {link.label}
                        </Link>
                        <ChevronRightIcon
                            className="w-3.5 h-3.5 text-gray-400"
                            aria-hidden="true"
                        />
                    </li>
                ))}
                <li className="text-gray-700 truncate" aria-current="page">
                    {current}
                </li>
            </ol>
        </nav>
    );
};
